"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alto-reno-terme": {
    "eb2c402a": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "biagioni": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "16f1ea26": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-capanne": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1b03a494": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "capugnano": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "af373150": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "casa-calistri": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "da53d5ee": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "casa-forlai": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34f6942d": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "castelluccio": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5f90a0df": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "corvella": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a2db1d9d": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "lustrola": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7b306122": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "molino-del-pallone": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d5933441": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-della-venturina": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "41331a5d": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "skipSearch": false
    }],
    "vizzero": [{
      "hkey": "6b1fb473",
      "slug": "alto-reno-terme",
      "name": "Alto Reno Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;